export default "__VITE_ASSET__DUogvJZ4__"